jQuery(document).ready(function ($) {
  /*----- utils -----*/
  const isMobile = () => {
    return $(window).width() <= 800;
  };


  /*----- review-page slider -----*/
  $('.reviews-slider').slick({
    infinite: true,
    slidesToShow: 3,
    arrows: true,
    prevArrow: `
    <div class="slick-prev">
      <svg width="15px" height="25px" viewBox="0 0 15 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-Guide-(UI-Kit)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Additional-Assets-(SVGs)" transform="translate(-132.000000, -21.000000)" fill="#7F7F7F">
            <polygon id="Left-Chevron" transform="translate(139.500000, 33.500000) scale(-1, 1) translate(-139.500000, -33.500000) " points="132 23.9166667 134.837838 21 147 33.5 134.837838 46 132 43.0833333 141.324324 33.5"></polygon>
          </g>
        </g>
      </svg>
	  </div>
  `,
    nextArrow: `
      <div class="slick-next">
      <svg width="15px" height="25px" viewBox="0 0 15 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Style-Guide-(UI-Kit)" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Additional-Assets-(SVGs)" transform="translate(-177.000000, -21.000000)" fill="#7F7F7F">
            <polygon id="Right-Chevron" points="177 23.9166667 179.837838 21 192 33.5 179.837838 46 177 43.0833333 186.324324 33.5"></polygon>
          </g>
        </g>
      </svg>
      </div>
    `,
    adaptiveHeight: true,
    dots: false,
    responsive: [
      {
        breakpoint: 1420,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1175,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
          focusOnSelect: true
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          arrows: false,
          centerMode: true,
          variableWidth: true,
          focusOnSelect: true
        }
      }
    ]
  })


  /*----- home-page slider -----*/
  $(window).on("resize", function() {
    const $homeSlider = $(".explore-slider");
    const $homeSliderData = $(".explore-slider").data("init-slider");

    if (isMobile()) {
      if ($homeSliderData !== 1) {
        $homeSlider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          adaptiveHeight: true,
          dots: true,
        }).data({"init-slider": 1});
      }
    } else {
      if ($homeSliderData === 1) {
        $homeSlider.slick("unslick").data({"init-slider": 0});
      }
    }
  }).trigger("resize");
});